import { StatCard } from '@/common/dashboard/StatCard';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';
import { Spacer } from '@/common/layout/SpacerLayout';

export const McoPhsCapCards = ({ formValues }) => {

    const { mcoInvId, prodIds, periodIds } = formValues;

    const rsrc = useRsrc();

    const [data, setData] = useState([]);

    useEffect(() => {
        if (!mcoInvId) {
            return;
        }

        const reqParam = {
            mcoInvId,
            prodIds,
            periodIds
        };

        rsrc.data('sc', 'MCO_PHS_CAP_CARDS_DATA_PLUGIN', reqParam).then(res => {
            setData(res);
        });
    }, [mcoInvId, prodIds, periodIds]);

    if (!data) {
        return null;
    }

    return (
        <Spacer>
            <Spacer vertical>
                <StatCard
                    title="Largest Dispute Percentage"
                    val={data.pctDispAmt}
                    isAmt={true}
                    pctChange={data.largestDispPct === 0 ? null : data.largestDispPct}
                    vsLabel={data.pctPeriodCode}
                    label={data.pctProdCode}
                    isVs={false}
                />
                <StatCard
                    title="Largest Dispute Amount"
                    val={data.largestDispAmt}
                    isAmt={true}
                    pctChange={data.amtDispPct === 0 ? null : data.amtDispPct}
                    vsLabel={data.amtPeriodCode}
                    label={data.amtProdCode}
                    isVs={false}
                />
            </Spacer>
        </Spacer>
    )
}